export enum ENROLLMENT_ACTIONS {
    CACNEL = 'cancel',
    SUBMIT = 'submit',
} 

export enum PLAN_TYPE {
    HEALTH = 'HEALTH',
    DENTAL = 'DENTAL',
    BOTH = 'BOTH',
}

export enum FROM_TAB {
    ENROLLMENTHISTORY = 'ENROLLMENTHISTORY',
    CUSTOMGROUPING = 'CUSTOMGROUPING',
    PLANSUMMARY = 'PLANSUMMARY'
}